//#region Dependencias
import React, {Component} from 'react';
import {BreadCumb, DataTables, NavBar,TimeOut} from "../../components";
import config from "../../config";
import moment from "moment";
import {DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient";
import {connect} from "react-redux";
//#endregion
const formatQty = (value) => {
    if (isNaN(value)) return "0.000";
    return Number(value).toFixed(3);
}

const formatDate = (value) => {
    const date = moment(value);
    if (date.isValid) return date.format("DD/MM/YYYY");
    return "--/--/----";
}

const formatType = (value) => {
    switch (value) {
        case "P": return "Pedido";
        case "Q": return "Oferta de Compra";
        case "R": return "Solicitud de Compra";
        case "T": return "Solicitud de Traslado";
        case "W": return "Orden de Fabricación";
        default: return "";
    }
}

//#region Variables globales
const apiClient = ApiClient.getInstance();
const headersDataTable = [
    { title: "Tipo de Docuemnto", value: true, field: "OrderType", format: formatType },
    { title: "Escenario", value: true, field: "MsnCode", format: null },
    { title: "Fecha de liberación", value: true, field: "DocDate", format: formatDate },
    { title: "Fecha de vencimiento", value: true, field: "DueDate", format: formatDate },
    { title: "Artículo", value: true, field: "ItemCode", format: null },
    { title: "Proveedor", value: true, field: "CardCode", format: null },
    { title: "Cantidad", value: true, field: "Quantity", format: formatQty },
    { title: "Almacén", value: true, field: "Warehouse", format: null }
]
//#endregion

//#region Componente
class ReportSelectionCriteriaView extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props)
        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }
    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liPlanesAdquisicion");
        let today =  moment(new Date()).format('YYYYMMDD');

        let date= {
            dateInit:today,
            dateFinal:today,
        }
        await this.callDocumentsListService(date);
    }
    //#endregion

    //#region Consultar Información
    callDocumentsListService = async params => {
        const {notificationReducer:  { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de los documentos
        let data = {
            dateInit: params.dateInit,
            dateFinal: params.dateFinal,
            switch1 : params.docStatus || '---',
            table: "OFLT",
            docNumSearch: params.docNumSearch ? params.docNumSearch === '' ? '--' : params.docNumSearch : '--', 
            searchSerieName: params.searchSerieName ? params.searchSerieName === '' ? '--' : params.searchSerieName : '--'
        };

        enableSpinner(true);
        let returnListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if(returnListResponse.status === SERVICE_RESPONSE.SUCCESS){
            returnListResponse = returnListResponse.data || [];

            if (returnListResponse.length === 0) {
                this.setState({ data: [] });
                return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
            }
            
            this.setState({ data: returnListResponse });
            return;
        } else {
            this.setState({ data: [] });
            return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
        }
    };
    //#endregion

    //#region Render
    render() {
        const { headers, data ,_user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <TimeOut/>
                <BreadCumb subitem1={'RECOMENDACIÓN DE PEDIDO'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>
                    <h2 className="md-display-1 text-muted"> &nbsp; RECOMENDACIÓN DE PEDIDO </h2>
                    <DataTables headers={headers} view={"reportSelectionCriteria"} data={data} search={this.callDocumentsListService} />
                </div>
            </div>
        );
    }
    //#endregion
}
//#endregion

//#region REDUX
const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};
//#endregion

export default connect( mapStateToProps, mapDispatchToProps )(ReportSelectionCriteriaView); // Exportar componente